<template>
  <div id="globalNewParams" class="warp">
    <!-- 头部搜索栏 -->
    <div>
      <div class="button" style="margin-bottom: 20px">
        <el-button
          type="primary"
          size="mini"
          class="edit-button"
          icon="el-icon-plus"
          @click="dialogEvent"
        >添加</el-button>
        <el-button type="success" size="mini" @click="getList">刷新</el-button>
        <el-button
          type="danger"
          size="mini"
          @click="delItemIds"
        >删除</el-button>
        <el-button
          type="primary"
          size="mini"
          class="edit-button"
          @click="getList"
        >筛选</el-button>
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="width: 44px">备注</label>
          <el-input
            v-model="remark"
            placeholder="请输入备注"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="width: 44px">key</label>
          <el-input
            v-model="key"
            placeholder="请输入key"
            size="mini"
            clearable
          />
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="table_warp">
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="paramsData"
        border
        style="width: 1401px"
        height="calc(100vh - 320px )"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="50" />
        <!-- 备注 -->
        <el-table-column label="备注" align="center" width="300">
          <template slot-scope="scoped">
            <div style="text-align: center">
              {{ scoped.row.remark }}
            </div>
          </template>
        </el-table-column>
        <!-- key -->
        <el-table-column label="key" width="300">
          <template slot-scope="scoped">
            <div style="text-align: center">
              {{ scoped.row.key }}
            </div>
          </template>
        </el-table-column>
        <!-- value -->
        <el-table-column label="values" width="300">
          <template slot-scope="scoped">
            {{ scoped.row.values }}
          </template>
        </el-table-column>
        <!-- type -->
        <el-table-column prop="type" label="type" width="100" />
        <!-- 创建时间-->
        <el-table-column prop="createdAt" label="创建时间" width="200">
          <template slot-scope="scoped">
            {{
              $parseTime(
                new Date(scoped.row.createdAt),
                "{y}-{m}-{d} {h}:{i}:{s}"
              )
            }}
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="address" label="操作" width="150">
          <template slot-scope="scoped">
            <div class="flex-center">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-edit"
                style="margin-right: 5px"
                @click="editDetails(scoped.row)"
              >编辑</el-button>
              <el-popconfirm
                :hide-icon="true"
                title="确定删除？"
                @onConfirm="delItem(scoped.row)"
              >
                <el-button
                  slot="reference"
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  style="margin-right: 10px"
                >删除</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNumber"
      :limit.sync="pageSize"
      :page-sizes="[2, 5, 10, 20, 50]"
      @pagination="next()"
    />
    <!-- 添加弹窗 -->
    <el-dialog
      :visible.sync="dialog"
      width="50%"
      :close-on-click-modal="false"
      :title="isEdit ? '编辑' : '添加'"
      @close="close"
    >
      <el-form
        ref="ruleForm"
        :model="formData"
        size="mini"
        label-width="100px"
        class="demo-ruleForm"
        :rules="rules"
      >
        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="formData.remark"
            placeholder="请输入备注"
            size="mini"
            style="width: 300px"
          />
        </el-form-item>
        <!-- key -->
        <el-form-item label="key:" prop="key">
          <el-input
            v-model="formData.key"
            placeholder="请输入key"
            size="mini"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item label="类型:" prop="type">
          <el-radio-group v-model="formData.type">
            <el-radio label="int">int </el-radio>
            <el-radio label="varchat">varchat </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="值:" prop="values">
          <el-input
            v-model="formData.values"
            placeholder="请输入值"
            size="mini"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item>
          <el-button @click="close">取消</el-button>
          <el-button
            type="primary"
            class="edit-button"
            @click="submitForm('ruleForm')"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
import { list, add, edit, remove } from '@/api/globalNewParams.js'
export default {
  name: 'GlobalNewParams',
  components: { Pagination },
  data() {
    return {
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      type: '',
      remark: '',
      key: '',
      loading: false, // 表格加载
      paramsData: [],
      choseItem: [], // 选中项
      dialog: false, // 弹窗标识
      formData: {
        remark: '',
        key: '',
        type: '',
        values: ''
      },
      isEdit: false,
      rules: {
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }],
        key: [{ required: true, message: '请输入key', trigger: 'change' }],
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }
        ],
        values: [
          {
            required: true,
            message: '请输入值',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 选择模块
    selectModule(item) {
      this.remark = item.remark
      this.getList()
    },
    // 获取列表数据
    getList() {
      this.loading = true
      var params = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        remark: this.remark,
        key: this.key
      }
      list(params)
        .then((res) => {
          console.log(res)
          this.paramsData = res.rows
          this.total = res.count
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 打开添加商品弹窗
    dialogEvent() {
      this.isEdit = false
      this.dialog = true
    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.id)
    },
    init() {
      this.formData = {
        remark: '',
        type: '',
        key: '',
        values: ''
      }
    },
    // 关闭添加弹窗
    close() {
      this.init()
      this.dialog = false
    },
    // 删除商品
    delItem(item) {
      this.multipleSelection = []
      this.multipleSelection.push(item.id)
      this.delItemIds()
    },
    delItemIds() {
      this.$confirm(
        '是否确认删除' + this.multipleSelection.length + '条数据?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          roundButton: true
        }
      ).then(() => {
        remove({ ids: this.multipleSelection }).then((res) => {
          this.$message.success('删除成功')
          this.getList()
        })
      })
    },
    // 下一页或刷新
    next() {
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.getList()
    },
    select() {
      this.pageNumber = 1
      this.getList()
    },
    // 添加新全局参数
    submitForm(formName) {
      console.log(this.formData, '00')
      this.$refs[formName].validate((valid) => {
        console.log(valid, 'va...')
        if (valid) {
          if (!this.formData.id) {
            add(this.formData)
              .then((res) => {
                this.$message.success('添加成功')
                this.pageNumber = 1
                this.getList()
                this.close()
              })
              .catch((err) => {
                this.$message.danger(err || '添加失败')
              })
          } else {
            edit(this.formData)
              .then(() => {
                this.$message.success('修改成功')
                this.pageNumber = 1
                this.getList()
                this.close()
              })
              .catch(() => {
                this.$message.danger('修改失败')
              })
          }
        }
      })
    },
    // 打开编辑弹窗
    editDetails(row) {
      console.log(row)
      this.formData = { ...this.formData, ...row }
      this.dialog = true
      this.isEdit = true
    }
  }
}
</script>
<style lang="scss" scoped>
#globalNewParams {
  .el-image {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .head_search {
    display: flex;
    width: 100%;
    margin-bottom: 20px;

    .item_warp {
      display: flex;

      .el-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }

      label {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #525252;
        font-weight: 400;
      }
    }
  }

  .green {
    color: #00c759;
  }

  .red {
    color: rgb(255, 62, 51);
  }

  .el-tag + .el-tag {
    margin-left: 3px;
  }

  .button-new-tag {
    margin-left: 10px;
    margin-top: 5px;
    height: 25px;
    line-height: 25px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .zhi {
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
  }

  .el-tag--mini {
    height: 20px;
    padding: 0px 5px;
    line-height: 19px;
    margin: 0px 0 2px 0;
  }
  .set-tag {
    cursor: pointer;
    background: rgba(236, 236, 255, 1);
    // border: 1px solid rgba(236, 236, 255, 1) ;
    color: #6663ff;
    font-weight: bold;
  }
}
</style>
